<template>
  <v-form @submit.prevent="submitForm">
    <h3>Add Debtor</h3>
    <p></p>
    <div class="my-2"></div>
    <v-row>
      <v-col :cols="12">
        <v-text-field v-model="formData.company_name" label="Bedrijfsnaam" variant="solo" :type="'text'"
          density="compact"></v-text-field>

        <v-text-field v-model="formData.first_name" label="Voornaam" variant="solo" :type="'text'"
          density="compact"></v-text-field>


        <v-text-field v-model="formData.last_name" label="Achternaam" variant="solo" :type="'text'"
          density="compact"></v-text-field>

        <v-text-field v-model="formData.email" label="E-mailadres" variant="solo" :type="'email'"
          density="compact"></v-text-field>

      </v-col>
    </v-row>
    <div class="text-right pb-4">
      <v-btn class="k-btn k-btn-light mr-2" light @click="$emit('update:close', false)" elevation="0"
        color="var(--neutral-100)">Annuleren</v-btn>
      <v-btn type="submit" class="k-btn text-white" dark elevation="0" color="var(--primary)">Aanmaken</v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {}, // Holds form data dynamically
    };
  },
  methods: {
    submitForm() {
      console.log(this.formData);
      this.$emit("form-submitted", this.formData); // Emit de data naar de parent
    },
  },
};
</script>
